import { useQuery } from '@tanstack/react-query';
import { useProfileStore } from 'src/features/stores/useProfileStore';
import { ObtCheckCompanyCardProfileInfoModel } from 'src/features/userProfileRefactor/types/ObtCheckCompanyCardProfileInfoModel';
import { getAxios } from 'src/lib/axios';

const checkCompanyCardProfileInfoQuery = async (
  isBusinessMode: boolean,
  selectedUserId: number
): Promise<ObtCheckCompanyCardProfileInfoModel> => {
  let url = `/api/onlinebookingprofile/checkCompanyCardProfileInfoQuery/${isBusinessMode}/?`;
  url += '&contactId=' + selectedUserId;
  return (await getAxios().get(url, {})).data;
};

export const useCheckCompanyCardProfileInfoQuery = (isBusinessMode: boolean, enabled: boolean) => {
  const { selectedUserId } = useProfileStore();

  return useQuery({
    queryKey: ['checkCompanyCardProfileInfoQuery', isBusinessMode],
    queryFn: () => checkCompanyCardProfileInfoQuery(isBusinessMode, selectedUserId!),
    enabled: enabled && !!selectedUserId // <--- only runs when selectedUserId is available
  });
};
